import { Avatar, Group, Paper, Rating, Text } from "@mantine/core";
import { Review } from "../../../../gql/__generated__/graphql";

interface ReviewCardProps {
  review: Review;
}

// Type guards for Reviewer
function isUser(
  reviewer: any
): reviewer is { name?: string | null; imageUrl?: string | null } {
  return reviewer && "name" in reviewer;
}

function isBrand(
  reviewer: any
): reviewer is { brandName: string; logo: string } {
  return reviewer && "brandName" in reviewer;
}

const ReviewCard = ({ review }: ReviewCardProps) => {
  let displayName = "Deactivated Account";
  let avatarSrc: string | undefined = undefined;

  if (isUser(review.reviewer)) {
    displayName = review.reviewer.name ?? "Deactivated Account";
    avatarSrc = review.reviewer.imageUrl ?? undefined;
  } else if (isBrand(review.reviewer)) {
    displayName = review.reviewer.brandName;
    avatarSrc = review.reviewer.logo;
  }

  return (
    <Paper p="md" withBorder>
      <Group>
        <Avatar src={avatarSrc} alt="Reviewer" radius="xl" />
        <div>
          <Text size="sm">{displayName}</Text>
          <Text size="xs" c="dimmed">
            {new Date(review.createdAt).toLocaleDateString()}
          </Text>
        </div>
      </Group>
      <Rating value={review.rating} readOnly mt="sm" />
      <Text mt="xs" size="sm">
        {review.comment}
      </Text>
    </Paper>
  );
};

export default ReviewCard;
